/** This file should not include supabase. */
import { invalidate } from '$app/navigation'
import { page } from '$app/state'
import type { Table } from '$lib/supabase'

export let preloadedSettings: Table<'settings'> | undefined

/**
 * If the user changed their settings locally, then you can call this function,
 * and invalidate supabase:auth. This will retrigger this load function, but not
 * require to load the settings data again.
 */
export const updateSettingsLocally = (update: Partial<Table<'settings'>>) => {
  const settings = page.data.session?.settings
  if (!settings) return
  preloadedSettings = { ...settings, ...update }
  invalidate('supabase:auth')
}
export const clearLocalSettings = () => (preloadedSettings = undefined)

export const reloadSettings = async () => {
  invalidate('supabase:auth')
}
